import _ from 'lodash';
import { sortAppsByType } from 'client/utils/cart';
import CartService from 'web-core/src/cart-service';

export const RECEIVE_CART_APPS = 'RECEIVE_CART_APPS';
export const RECEIVE_PURCHASED_APPS = 'RECEIVE_PURCHASED_APPS';

const receiveCartApps = apps => ({
  type: RECEIVE_CART_APPS,
  apps,
});

export const fetchCart = params => (dispatch, getState, { apiClient }) => {
  const svc = new CartService({ client: apiClient });
  return svc.get(params).then((response) => {
    if (_.isArray(response)) {
      const sortedApps = sortAppsByType(response);
      dispatch(receiveCartApps(sortedApps));
      return sortedApps;
    }
    return response;
  });
};

const receivePurchasedApps = apps => ({
  type: RECEIVE_PURCHASED_APPS,
  apps,
});

export const purchaseCart = ({ appIds, billingId, effectiveDate }) => (
  dispatch,
  getState,
  { apiClient },
) => {
  const svc = new CartService({ client: apiClient });
  return svc.purchase({ appIds, billingId, effectiveDate }).then((response) => {
    dispatch(receivePurchasedApps(response));
    return response;
  });
};
